/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 11:26:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2023-01-03 09:40:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/MenuSortableTree/index.tsx
 */
/**
 * Component to test other trial component
 * Author: Chris
 * CreatedAt: 2021-3-22
 */

import React from 'react';
import { withRouter } from 'react-router-dom';
//import Slug from 'src/constrains/SlugInput';
//import EditorDemo from 'src/constrains/BraftEditor';
import Container from 'src/components/DragContainers/LeftMenuIconDragContainer';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import AddNew from 'src/components/GreenAddBtn/GreenAddBtn';
import SortableTree from 'src/constrains/SortableTree';
import { useI18n } from 'src/hooks/useRouterChange';
import { titleGenerator } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import { dataFromServer, generateNewItem } from './tools';
export { dataFromServer, generateNewItem };
const MenuSortableTree = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onChange,
    onEdit,
    onDelete,
    onAdd,
    multiLanguageDisabled,
    disableEdit,
  } = props;

  return (
    <React.Fragment>
      <SortableTree
        disabled={multiLanguageDisabled}
        tree={data}
        //containerCss={css.sortableTreeContainer}
        onChange={onChange}
        childGenerator={(node, path) => {
          return (
            <Container
              dragDisabled={multiLanguageDisabled}
              contentContainerClassName={css.contentContainerClassName}
              data-tester-title={titleGenerator(node.title)}
              containerClassName={css.containerClassName}>
              <TextAndEditIcon
                //           warningModalTitle={}
                // warningModalContent={}
                // displayWarningModalWhenDeleting={true}
                disabled={disableEdit}
                containerClassName={`${css.rowContainerClassName} ${
                  multiLanguageDisabled ? css.noDelete : ''
                }`}
                name={node.title}
                {...(onDelete
                  ? {
                      onDelete: () => {
                        if (onDelete) onDelete(node);
                      },
                    }
                  : {})}
                onClick={() => {
                  if (onEdit) onEdit(node);
                }}
              />
            </Container>
          );
        }}
      />
      {/* {onAdd && ( */}
      <AddNew
        addFun={
          onAdd
            ? onAdd
            : () => {
                return;
              }
        }
        addText={
          onAdd ? (
            `+ ${getI18n('salesChannelContent.index.addMenuItem')}`
          ) : (
            <span style={{ color: '#fff' }}>-</span>
          )
        }
        className={`${css.addNewContainer}`}
      />
      {/* // )} */}
    </React.Fragment>
    // <EditorDemo />
  );
};
export default withRouter(MenuSortableTree);
